module.exports = __webpack_public_path__ + "img/google_cloud_icon.d87afdbb.svg";